import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import { Typography, Divider, Box, Grid } from "@mui/material";
import Review from "./Review";
import {
  db,
  collection,
  query,
  getDocs,
  orderBy,
  doc,
  getDoc,
} from "../../firebase";
import { HashLink } from "react-router-hash-link";
import ReviewRatingStar from "../Products/Product/ReviewRatingStar";
import { useAuth } from "../../context/AuthContext";
import { useTranslation } from "react-i18next";
import CheckIcon from "@mui/icons-material/Check";

const Root = styled("div")(({ theme }) => ({
  width: "100%",

  ...theme.typography.body2,
  "& > :not(style) + :not(style)": {
    marginTop: theme.spacing(2),
  },
}));

const Reviews = ({ productId, name, link, rating }) => {
  const [location, setLocation] = useState(
    JSON.parse(window.sessionStorage.getItem("iplookup")).countryCode
  );
  const { t, i18n } = useTranslation();
  const productName = name;
  const [reviews, setReviews] = useState([]);
  const [reviewsUS, setReviewsUS] = useState([]);
  const [reviewsKO, setReviewsKO] = useState([]);
  const [user, setUser] = useState(null);
  const [purchases, setPurchases] = useState([]);
  const [block, setBlock] = useState(false);
  const { currentUser } = useAuth();

  const [ratingUS, setRatingUS] = useState(5);
  const [ratingKO, setRatingKO] = useState(5);
  const [ratingOverall, setRatingOverall] = useState(5);

  console.log("purchases", purchases);

  useEffect(() => {
    getReviews();
    getUser();
    return () => {
      setReviews([]);
      setUser(null);
    };
  }, []);

  const change = (e, value) => {
    setLocation(value);
    getReviewsWithLoc(value);
  };
  const getReviews = async () => {
    setReviews([]);
    // let dbName =
    //   JSON.parse(window.sessionStorage.getItem("iplookup")).countryCode +
    //   "_" +
    //   "reviews_" +
    //   productId;
    let dbName = "KO" + "_" + "reviews_" + productId;
    console.log("dbName", dbName);

    let ref = await collection(db, dbName);
    const q = query(ref, orderBy("created", "desc"));
    const querySnapshot = await getDocs(q);
    let num1 = 0;
    let length = 0;
    querySnapshot.forEach((doc) => {
      setReviewsKO((old) => old.concat({ ...doc.data(), id: doc.id }));
      num1 = num1 + doc.data().rating;
      length++;
      console.log("rating num1", num1);
    });
    console.log("length rating", length);
    if (+num1 / +length > 0) {
      setRatingKO((old) => +num1 / +length);
    } else {
      setRatingKO((old) => 0);
    }

    // US REVIEWS
    let dbName2 = "US" + "_" + "reviews_" + productId;
    console.log("dbName2", dbName2);
    let ref2 = await collection(db, dbName2);
    const q2 = query(ref2, orderBy("created", "desc"));
    const querySnapshot2 = await getDocs(q2);
    let num2 = 0;
    let length2 = 0;
    querySnapshot2.forEach((doc) => {
      num2 = num2 + doc.data().rating;
      length2++;
      setReviewsUS((old) => old.concat({ ...doc.data(), id: doc.id }));
    });
    if (+num2 / +length2 > 0) {
      setRatingUS(+num2 / +length2);
    } else {
      setRatingUS((old) => 0);
    }

    setRatingOverall(num1 + num2 / length + length2);
  };
  const getReviewsWithLoc = async (location) => {
    setReviews(null);
    console.log("location", location);
    if (location === "US") {
      setReviews((old) => reviewsUS);
    } else {
      setReviews((old) => reviewsKO);
    }
  };

  const getUser = async () => {
    if (currentUser) {
      const docRef = doc(db, "users", currentUser.uid);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        setUser(docSnap.data());
        setPurchases(docSnap.data().purchases);
        setBlock(docSnap.data().block);
      } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
      }
    }
  };

  console.log("ratingKO", ratingKO);
  console.log("ratingUS", ratingUS);
  console.log("ratingOverall", ratingOverall);
  return (
    <Root>
      <Grid
        sx={{
          paddingBottom: "40px",
          // border: "1px solid black",
          mx: { md: 15, sm: 1, xs: 1 },
        }}
      >
        <Typography sx={{ paddingBottom: "10px", pt: 10, fontSize: "17px" }}>
          {t("Read our customer's reviews")}
        </Typography>
        <Box
          sx={{
            color: "gray",
            display: "flex",
            justifyContent: "space-between",
            pb: 2,
          }}
        >
          <Box>
            1-{Math.round(reviews?.length / 4)} of {reviews?.length}{" "}
            {t("Reviews")}{" "}
          </Box>
          <Box>
            {t("Average Customer Ratings")}
            <Box sx={{ display: "flex" }}>
              <Box
                sx={{
                  paddingTop: "19px",
                  paddingRight: "3px",
                  fontSize: "13px",
                }}
              >
                {t("Overall")}
              </Box>
              <ReviewRatingStar rating={ratingOverall} />
            </Box>
            <Box sx={{ display: "flex", position: "relative", top: "-10px" }}>
              <Box
                sx={{
                  paddingTop: "19px",
                  paddingRight: "3px",
                  fontSize: "13px",
                }}
              >
                한국 후기
              </Box>
              <ReviewRatingStar rating={ratingKO} />
            </Box>
            <Box sx={{ display: "flex", position: "relative", top: "-20px" }}>
              <Box
                sx={{
                  paddingTop: "19px",
                  paddingRight: "3px",
                  fontSize: "13px",
                }}
              >
                미국 후기
              </Box>
              <ReviewRatingStar rating={ratingUS} />
            </Box>
          </Box>
        </Box>
        <Box sx={{ display: "flex" }}>
          <Box></Box>
          <Box>
            {location === "KO" ? (
              <CheckIcon sx={{ fontSize: "13px" }} />
            ) : (
              <CheckIcon sx={{ fontSize: "13px", visibility: "hidden" }} />
            )}{" "}
            <span
              className="pink_link"
              style={{ cursor: "pointer", fontSize: "12px" }}
              onClick={(e) => change(e, "KO")}
            >
              {t("Korea Reviews")}
            </span>
          </Box>
          <Box sx={{ pl: 2 }}>
            {location === "US" ? (
              <CheckIcon sx={{ fontSize: "13px" }} />
            ) : (
              <CheckIcon sx={{ fontSize: "13px", visibility: "hidden" }} />
            )}{" "}
            <span
              className="pink_link"
              style={{ cursor: "pointer", fontSize: "12px" }}
              onClick={(e) => change(e, "US")}
            >
              {t("US Reviews")}
            </span>
          </Box>
        </Box>
        <Divider textAlign="left" sx={{ pt: 2 }}></Divider>

        {reviews.map((review, idx) => {
          console.log("Reviews Review", review);
          if (idx < 3) {
            if (review.admin) {
              return (
                <Review
                  key={idx}
                  productName={productName}
                  id={review.id}
                  rating={review.rating}
                  name={review.name}
                  title={review.title}
                  review={review.comment}
                  imgs={review.images}
                  created={review.created}
                  uid={review.uid}
                  link={link}
                  productId={productId}
                  admin={review.admin}
                />
              );
            } else {
              return (
                <Review
                  key={idx}
                  productName={productName}
                  id={review.id}
                  rating={review.rating}
                  name={review.name}
                  title={review.title}
                  review={review.comment}
                  imgs={review.images}
                  created={review.created}
                  uid={review.uid}
                  link={link}
                  productId={productId}
                />
              );
            }
          }
        })}
        {reviews.length === 0 ? (
          <Box sx={{ width: 1, textAlign: "center", pt: 2, color: "gray" }}>
            {t("Be the first to review this item")}
          </Box>
        ) : null}
      </Grid>

      <Grid
        container
        sx={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
          justifyContent: "center",
          pb: 20,
        }}
      >
        {reviews.length > 0 ? (
          <Grid
            item
            md={3}
            sm={12}
            xs={12}
            sx={{
              mb: { xs: 1, md: 0, sm: 1 },
              px: { md: 1, sm: 0, xs: 0 },
              boxSizing: "content-box",
            }}
          >
            <HashLink
              to={
                "/all-reviews?location=" +
                location +
                "&productId=" +
                productId +
                "&name=" +
                name +
                "&link=" +
                link +
                "#top"
              }
            >
              <button
                className="custom_btn"
                style={{
                  width: { md: "300px", sm: 1 },
                }}
              >
                {t("View All Reviews")}
              </button>
            </HashLink>
          </Grid>
        ) : null}

        {purchases?.includes(productId) && !block ? (
          <Grid
            item
            md={3}
            sm={12}
            xs={12}
            sx={{
              mb: { xs: 1, md: 0, sm: 1 },
              px: { md: 1, sm: 0, xs: 0 },
              boxSizing: "content-box",
            }}
          >
            <HashLink
              to={
                "/leave-a-review?productId=" +
                productId +
                "&name=" +
                name +
                "&link=" +
                link +
                "#top"
              }
            >
              <button
                className="custom_btn"
                sx={{
                  width: "300px",
                  marginLeft: { md: "20px", sm: 0 },
                }}
              >
                {t("Write a review")}
              </button>
            </HashLink>
          </Grid>
        ) : null}

        <Grid
          item
          md={3}
          sm={12}
          xs={12}
          sx={{
            mb: { xs: 1, md: 0, sm: 1 },
            px: { md: 1, sm: 0, xs: 0 },
            boxSizing: "content-box",
          }}
        >
          <HashLink to={"#top"}>
            <button
              className="custom_btn_whitebg"
              sx={{ marginLeft: { md: "20px", sm: 0 }, width: "300px" }}
            >
              {t("Go back To Top")}
            </button>
          </HashLink>
        </Grid>
      </Grid>
    </Root>
  );
};

export default Reviews;
